import React from 'react';
import { View, Text } from 'react-native';
import { TextInput } from 'react-native-paper';

import HeaderDefault from '../../components/HeaderDefault';
import Button from '../../components/Button';

import styles from './styles';

const ConfirmSearchUserSell = () => {
    return (
        <>
            <HeaderDefault title={"Buscar"} />

            <View style={styles.container}>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Moeda:</Text>
                    <Text>GPX Token</Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Valor do dia:</Text>
                    <Text>XX,XXX.XXGPX</Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Recebedor:</Text>
                    <Text>Abelardo Bueno da Costa</Text>
                </View>

                <Text style={styles.descriptionInput}>Definir valor de venda:</Text>

                <TextInput
                    left={<TextInput.Icon name="currency-brl" />}
                    style={{ backgroundColor: "#F2F2F2", marginTop: 20 }}
                    keyboardType="numeric"
                />
                <Text style={styles.price}>1GPX = XBRL (cotação)</Text>
            </View>

            <Button route={"ConfirmPassword"} text={"CONFIRMAR"} titlePage={"Confirmar venda"} />
        </>
    );
}

export default ConfirmSearchUserSell;